import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

export const KpiSkeleton = styled.div`
  width: 60%;
  height: 32px;
  margin-top: 10px;
  margin-bottom: 8px;
  border-radius: 4px;
  background: linear-gradient(90deg, #ececef 0%, #f7f7fa 50%, #ececef 100%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

export const KpiCardStyles = styled.div`
  display: flex;
  flex-direction: column;

  .kpi-card {
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: ${({ theme }) => theme.radius[12]};
    height: 100%;
  }

  .kpi-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .kpi-card__label {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-weight: 500;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .kpi-card__value {
    font-size: 32px;
    line-height: 38px;
    font-weight: 600;
    letter-spacing: -0.5px;
    margin-top: 4px;
    color: ${({ theme }) => theme.colors.accent[500]};
    font-variant-numeric: tabular-nums;
  }

  .kpi-card__suffix {
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-left: 2px;
  }

  .kpi-card__foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    gap: 12px;
    min-height: 24px;
  }

  .kpi-card__hint {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }
`;
